import { MODAL_CLOSE_ON_BACK_HANDLES } from './modal-close-on-back.registry';

/**
 * Class decorator for modal components. Registers the modal so that browser back
 * closes the modal instead of navigating. The component must define static `handle`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- decorator target is any class with static handle
export function CloseModalOnBrowserBack() {
  return (target: any): void => {
    const handle = target?.handle;
    if (typeof handle === 'string') {
      MODAL_CLOSE_ON_BACK_HANDLES.add(handle);
    }
  };
}
